module.exports = __webpack_public_path__ + "img/sceneIcon3-2.656011ff.png";